import { Button } from 'primereact/button';
import { useAppSelector } from '../../redux/hooks';
import { selectUser } from '../../redux/reducers/userSlice';
import { Roles } from '../../models/User';
import { Dispatch, FC, SetStateAction } from 'react';
import { AssignmentEntryPoint, SelectAssignmentModeModal as SelectAssignmentModeModal } from '../../models/Assignment';
import { TargetSkillTypeLabel } from '../../models/TargetSkillType';

interface Props {
  setCreateAssignmentModal: Dispatch<SetStateAction<SelectAssignmentModeModal>>;
  /** Where this button is rendered, carried through to the assignment_created event. */
  entryPoint: AssignmentEntryPoint;
  skill: {
    id: string;
    code: string;
    name: string;
    targetSkillType?: TargetSkillTypeLabel;
  };
  customHeight?: boolean;
}

export const AssignmentOpenModalButton: FC<Props> = ({
  setCreateAssignmentModal,
  entryPoint,
  skill,
  customHeight = false,
}) => {
  const user = useAppSelector(selectUser);
  const isNetworkAdmin = user?.roles.some(role => role.name === Roles.NETWORK_ADMIN);
  return (
    <Button
      className={`mx-2 ${isNetworkAdmin ? 'hidden' : ''} ${customHeight ? 'tw-h-auto' : 'h-full'}`}
      label="Assign"
      outlined
      disabled={!user?.hasUserClassWithActiveStudent}
      onClick={() => {
        setCreateAssignmentModal({
          visible: true,
          skill: {
            ...skill,
            entryPoint,
            targetSkillType: skill.targetSkillType ?? TargetSkillTypeLabel.TARGET,
          },
        });
      }}
    />
  );
};
